"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.networkToTronLogsApiUrl = exports.networkToTronEventsApiUrl = exports.networkToTronApiUrl = exports.getNetwork = exports.getNetworkByChainId = exports.networks = void 0;
exports.networks = [{ chainId: 11111, network: "mainnet", genesisBlockHash: "0x00000000000000001ebf88508a03865c71d452e25f4d51194196a1d22b6653dc" },
    { chainId: 201910292, network: "nile", genesisBlockHash: "0x0000000000000000d698d4192c56cb6be724a558448e2684802de4d6cd8690dc" },
    { chainId: 1, network: "shasta", genesisBlockHash: "0x0000000000000000de1aa88295e1fcf982742f773e0419c5a9c134c994a9059e" }];
function getNetworkByChainId(e) {
    var r = parseInt(e, 10), n = exports.networks.find((function (e) { return e.chainId === r; }));
    if (!n)
        throw new Error('unknown network with chain id "'.concat(r, '". possible values: ').concat(exports.networks.map((function (e) { return e.chainId; })).join(", ")));
    return n;
}
exports.getNetworkByChainId = getNetworkByChainId;
function getNetwork(network) {
    var r = network.toLowerCase();
    const n = exports.networks.find(function (e) { return e.network === r; });
    if (!n)
        throw new Error('unknown network with chain id "'.concat(r, '". possible values: ').concat(exports.networks.map((function (e) { return e.chainId; })).join(", ")));
    return n;
}
exports.getNetwork = getNetwork;
function networkToTronApiUrl(network = "mainnet") {
    switch (network) {
        case "mainnet": return "https://java-tron.opentron.org";
        case "shasta": return "https://api.shasta.trongrid.io";
        case "nile": return "https://java-tron-nile.opentron.org";
        default: throw new Error('Unknown Tron network "'.concat(network, '", no API url mapping found'));
    }
}
exports.networkToTronApiUrl = networkToTronApiUrl;
function networkToTronEventsApiUrl(network = "mainnet") {
    switch (network) {
        case "nile": return "https://event.nileex.io";
        default: throw new Error('No events API url mapping found for network "'.concat(network, '"'));
    }
}
exports.networkToTronEventsApiUrl = networkToTronEventsApiUrl;
function networkToTronLogsApiUrl(network = "mainnet") {
    switch (network) {
        case "mainnet": return "https://logs.opentron.org";
        default: throw new Error('No logs API url mapping found for network "'.concat(network, '"'));
    }
}
exports.networkToTronLogsApiUrl = networkToTronLogsApiUrl;
